import { render, staticRenderFns } from "./Checkboard.vue?vue&type=template&id=57e17ec5"
import script from "./Checkboard.vue?vue&type=script&lang=js"
export * from "./Checkboard.vue?vue&type=script&lang=js"
import style0 from "./Checkboard.vue?vue&type=style&index=0&id=57e17ec5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports